import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const ClinicHours = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const headingsDays = [
    'Sunday',
    'Monday', 
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  const [hoursData, setHoursData] = useState({});

  const [showTimePicker, setShowTimePicker] = useState(false);
  const [timePickVal, setTimePickVal] = useState(new Date());
  const [activeRecord, setActiveRecord] = useState({
    day: 0,
    time: 1,
    fieldType: 'start_time',
  });

  useEffect(() => {
    getProfileApi();
  }, []);

  function getProfileApi() {
    const token = localStorage.getItem("tokenly_token");
    if (!token) {
      setError("No token found. Please login again.");
      return;
    }

    setLoading(true);
    setError('');

    fetch("https://tokenly.biswaas.com/api/user-detail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ page: 'docProfile' }),
    })
    .then(res => res.json())
    .then(data => {
      if (!data.status) {
        setError(data.message || "Failed to load profile data.");
      } else {
        let HoursJson = {};
        let newHourData = {};
        let closeDay = [false, false, false, false, false, false, false];
        
        if (data.data.hours != null && data.data.hours != '') {
          HoursJson = JSON.parse(data.data.hours);

          // Parse closed days
          if (HoursJson.Sunday?.is_closed == 1) closeDay[0] = true;
          if (HoursJson.Monday?.is_closed == 1) closeDay[1] = true;
          if (HoursJson.Tuesday?.is_closed == 1) closeDay[2] = true;
          if (HoursJson.Wednesday?.is_closed == 1) closeDay[3] = true;
          if (HoursJson.Thursday?.is_closed == 1) closeDay[4] = true;
          if (HoursJson.Friday?.is_closed == 1) closeDay[5] = true;
          if (HoursJson.Saturday?.is_closed == 1) closeDay[6] = true;

          // Parse time data
          if (HoursJson.Sunday?.time) newHourData.TimeItem0 = HoursJson.Sunday.time;
          if (HoursJson.Monday?.time) newHourData.TimeItem1 = HoursJson.Monday.time;
          if (HoursJson.Tuesday?.time) newHourData.TimeItem2 = HoursJson.Tuesday.time;
          if (HoursJson.Wednesday?.time) newHourData.TimeItem3 = HoursJson.Wednesday.time;
          if (HoursJson.Thursday?.time) newHourData.TimeItem4 = HoursJson.Thursday.time;
          if (HoursJson.Friday?.time) newHourData.TimeItem5 = HoursJson.Friday.time;
          if (HoursJson.Saturday?.time) newHourData.TimeItem6 = HoursJson.Saturday.time;
        } else {
          newHourData = {
            TimeItem0: [{end_time: '', start_time: ''}],
            TimeItem1: [{end_time: '', start_time: ''}],
            TimeItem2: [{end_time: '', start_time: ''}],
            TimeItem3: [{end_time: '', start_time: ''}],
            TimeItem4: [{end_time: '', start_time: ''}],
            TimeItem5: [{end_time: '', start_time: ''}],
            TimeItem6: [{end_time: '', start_time: ''}],
          };
        }
        newHourData.closeDay = closeDay;
        setHoursData(newHourData);
      }
      setLoading(false);
    })
    .catch(err => {
      setError("Something went wrong. Please try again.");
      setLoading(false);
    });
  }

  const onChangeTime = (textinp, in1, indx, end_time_field, values, setFieldValue) => {
    let valArr = [];
    if (in1 == 0) valArr = values.TimeItem0;
    else if (in1 == 1) valArr = values.TimeItem1;
    else if (in1 == 2) valArr = values.TimeItem2;
    else if (in1 == 3) valArr = values.TimeItem3;
    else if (in1 == 4) valArr = values.TimeItem4;
    else if (in1 == 5) valArr = values.TimeItem5;
    else if (in1 == 6) valArr = values.TimeItem6;

    if (end_time_field == 'end_time') {
      valArr[indx].end_time = textinp;
    } else if (end_time_field == 'start_time') {
      valArr[indx].start_time = textinp;
    }
    setFieldValue('TimeItem' + in1, valArr);
    setShowTimePicker(false);
    return false;
  };

  const handleSubmit = (values) => {
    let closeDayData = values.closeDay;
    let iscloseDay = false;
    let hourErrorData = false;

    for (let in1 = 0; in1 < 7; in1++) {
      iscloseDay = closeDayData[in1];
      if (iscloseDay) continue;
      
      let valArr = [];
      if (in1 == 0) valArr = values.TimeItem0;
      else if (in1 == 1) valArr = values.TimeItem1;
      else if (in1 == 2) valArr = values.TimeItem2;
      else if (in1 == 3) valArr = values.TimeItem3;
      else if (in1 == 4) valArr = values.TimeItem4;
      else if (in1 == 5) valArr = values.TimeItem5;
      else if (in1 == 6) valArr = values.TimeItem6;

      for (let valData of valArr) {
        if (valData.end_time == '' || valData.end_time == null || 
            valData.start_time == '' || valData.start_time == null) {
          hourErrorData = true;
        }
      }
    }

    if (hourErrorData) {
      setError('Some time field is empty');
      return false;
    }

    setLoading(true);
    setError('');

    const token = localStorage.getItem("tokenly_token");
    if (!token) {
      setError("No token found. Please login again.");
      setLoading(false);
      return;
    }

    // Update with correct API endpoint
    fetch("https://tokenly.biswaas.com/api/user/clenic-hours-update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(values),
    })
    .then(res => res.json())
    .then(data => {
      handleResponse(data);
    })
    .catch(err => {
      setError("Something went wrong. Please try again.");
      setLoading(false);
    });
  };

  function handleResponse(response) {
    setLoading(false);
    if (!response.status) {
      setError(response.message || "Update failed.");
    } else {
      setSuccess(response.message || "Clinic hours updated successfully!");
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
  }

  const getInitialValues = () => {
    return {
      TimeItem0: hoursData.TimeItem0 || [{start_time: '', end_time: ''}],
      TimeItem1: hoursData.TimeItem1 || [{start_time: '', end_time: ''}],
      TimeItem2: hoursData.TimeItem2 || [{start_time: '', end_time: ''}],
      TimeItem3: hoursData.TimeItem3 || [{start_time: '', end_time: ''}],
      TimeItem4: hoursData.TimeItem4 || [{start_time: '', end_time: ''}],
      TimeItem5: hoursData.TimeItem5 || [{start_time: '', end_time: ''}],
      TimeItem6: hoursData.TimeItem6 || [{start_time: '', end_time: ''}],
      closeDay: hoursData.closeDay || [false, false, false, false, false, false, false],
    };
  };

  const [formValues, setFormValues] = useState(getInitialValues());

  useEffect(() => {
    setFormValues(getInitialValues());
  }, [hoursData]);

  const handleFieldChange = (field, value) => {
    setFormValues(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const addTimeSlot = (dayIndex) => {
    const timeItem = `TimeItem${dayIndex}`;
    const currentTimeSlots = [...formValues[timeItem]];
    if (currentTimeSlots.length < 5) {
      currentTimeSlots.push({ start_time: '', end_time: '' });
      handleFieldChange(timeItem, currentTimeSlots);
    }
  };

  const removeTimeSlot = (dayIndex, slotIndex) => {
    const timeItem = `TimeItem${dayIndex}`;
    const currentTimeSlots = [...formValues[timeItem]];
    if (currentTimeSlots.length > 1) {
      currentTimeSlots.splice(slotIndex, 1);
      handleFieldChange(timeItem, currentTimeSlots);
    }
  };

  const toggleDayOff = (dayIndex) => {
    const newCloseDay = [...formValues.closeDay];
    newCloseDay[dayIndex] = !newCloseDay[dayIndex];
    handleFieldChange('closeDay', newCloseDay);
  };

  const openTimePicker = (dayIndex, slotIndex, fieldType) => {
    setActiveRecord({
      day: dayIndex,
      time: slotIndex,
      fieldType: fieldType,
    });
    setShowTimePicker(true);
  };

  const handleTimeSelect = (time) => {
    const textTime = moment(time).format('h:mm A');
    const timeItem = `TimeItem${activeRecord.day}`;
    const currentTimeSlots = [...formValues[timeItem]];
    
    currentTimeSlots[activeRecord.time][activeRecord.fieldType] = textTime;
    handleFieldChange(timeItem, currentTimeSlots);
    
    setShowTimePicker(false);
  };

  return (
    <>
      {/* Hero Section with Background Image - Same as other pages */}
      <section className="contact-hero d-flex align-items-center">
        <div className="contact-hero-overlay"></div>
        <div className="container-fluid container-xl px-4 px-md-3">
          <h1 className="display-5 fw-bold text-white mb-1">Clinic <span className="text-warning">Hours</span></h1>
          <p className="text-light mb-0">
            Manage your clinic schedule and availability
          </p>
        </div>
      </section>

      <div className="container-xl mt-4">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header bg-primary text-white">
                <h4 className="mb-0">Manage Clinic Hours</h4>
              </div>
              <div className="card-body">
                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                {isLoading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div>
                    {headingsDays.map((day, dayIndex) => {
                      const timeSlots = formValues[`TimeItem${dayIndex}`] || [];
                      const isDayOff = formValues.closeDay[dayIndex];

                      return (
                        <div key={dayIndex} className="border-bottom pb-3 mb-3">
                          <div className="row align-items-start">
                            <div className="col-md-3">
                              <h6 className="fw-bold">{day}</h6>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`off-${dayIndex}`}
                                  checked={isDayOff}
                                  onChange={() => toggleDayOff(dayIndex)}
                                />
                                <label className="form-check-label" htmlFor={`off-${dayIndex}`}>
                                  Off
                                </label>
                              </div>
                            </div>
                            <div className="col-md-9">
                              {!isDayOff && (
                                <div>
                                  {timeSlots.map((slot, slotIndex) => (
                                    <div key={slotIndex} className="d-flex align-items-center mb-2">
                                      <span className="me-2">S{slotIndex + 1}</span>
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm me-2"
                                        onClick={() => openTimePicker(dayIndex, slotIndex, 'start_time')}
                                        style={{ minWidth: '120px' }}
                                      >
                                        {slot.start_time || 'Set In Time'}
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm me-2"
                                        onClick={() => openTimePicker(dayIndex, slotIndex, 'end_time')}
                                        style={{ minWidth: '120px' }}
                                      >
                                        {slot.end_time || 'Set Out Time'}
                                      </button>
                                      {slotIndex === 0 && timeSlots.length < 5 ? (
                                        <button
                                          type="button"
                                          className="btn btn-outline-success btn-sm"
                                          onClick={() => addTimeSlot(dayIndex)}
                                          style={{ width: '36px', height: '31px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                          +
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          className="btn btn-outline-danger btn-sm"
                                          onClick={() => removeTimeSlot(dayIndex, slotIndex)}
                                          style={{ width: '36px', height: '31px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                          -
                                        </button>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}

                    <div className="text-center mt-4">
                      <button
                        type="button"
                        className="btn btn-primary px-5"
                        onClick={() => handleSubmit(formValues)}
                        disabled={isLoading}
                      >
                        {isLoading ? 'Saving...' : 'Submit'}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Time Picker Modal */}
      {showTimePicker && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Time</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowTimePicker(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  type="time"
                  className="form-control"
                  onChange={(e) => {
                    const time = e.target.value;
                    if (time) {
                      const [hours, minutes] = time.split(':');
                      const date = new Date();
                      date.setHours(parseInt(hours));
                      date.setMinutes(parseInt(minutes));
                      handleTimeSelect(date);
                    }
                  }}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowTimePicker(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ClinicHours;